import React from 'react';

function WatchLessons() {
  return (
    <div></div>
  );
}

export default WatchLessons;